export default __webpack_public_path__ + "static/media/About-Logo.37a5066b.svg";